import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import OverlaySpinner from "../../../../platform/shared/OverlaySpinner";
import ADVERTISER from "../../../GraphQl/Queries/ADVERTISER";

const AdvertiserDetailsLoader = props => {
  const { match } = props;
  const { params } = match;
  const { id } = params;

  const { data, loading } = useQuery(ADVERTISER, {
    variables: { id },
  });

  if (loading) return <OverlaySpinner />;

  return React.cloneElement(props.children, {
    ...props.children.props,
    advertiser: data ? data.advertiser : null,
  });
};

export default withRouter(AdvertiserDetailsLoader);
